import { render, staticRenderFns } from "./InquiryToProvider.vue?vue&type=template&id=0b1c2642&scoped=true&"
import script from "./InquiryToProvider.vue?vue&type=script&lang=ts&"
export * from "./InquiryToProvider.vue?vue&type=script&lang=ts&"
import style0 from "./InquiryToProvider.vue?vue&type=style&index=0&id=0b1c2642&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1c2642",
  null
  
)

export default component.exports